import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styles from './style.module.less'
import classNames from 'classnames'
import { getObjValue } from '@hlj/hlj-utils'
import LoginSub from '@components/LocalMerchant/SiDa/Common/LoginSub'
import { getMerchantInfo } from '@util'
import { Tooltip } from 'hljd'
import { Flex } from 'hljd'
import { getLinkTeam, getContentTeam } from '../../config'

@inject('store')
@observer
export default class extends Component {
  getItem = item => {
    const { getNoticeName, getMessage, goto } = this.props.store
    const { notify_type, action } = item
    const tranObj = getNoticeName(notify_type)
    const message = getMessage(item)
    const noticeContent = getContentTeam(item)
    const linkUrl = getLinkTeam(item)
    let qa_content = '' // 问答的内容
    if (notify_type == 16) {
      if (action == 'qa_answer_merchant') {
        qa_content = item.content || ''
      }
      if (action == 'qa_question_merchant') {
        qa_content = getObjValue(item, 'extra_objects.expand.title')
      }
    }
    const merchant_name = getObjValue(item, 'merchant_info.name')
    let merchant_city = getObjValue(item, 'merchant_info.city_info.city') || ''
    const noticeMerchantId = getObjValue(item, 'merchant_info.id')
    const merchantId = getMerchantInfo().id
    const is_main_merchant = noticeMerchantId == merchantId //是否为当前商家的通知

    if (merchant_city) {
      merchant_city = ' | ' + merchant_city
    }
    return (
      <li
        className={classNames(styles.item, {
          [styles.itemPointer]: !!linkUrl && is_main_merchant
        })}
        key={item.id}
        onClick={goto(item, message, linkUrl, is_main_merchant)}
      >
        <div className={classNames(styles.itemLeft, styles[tranObj.style])}>
          {item.status != 2 ? <span className={styles.dot} /> : ''}
        </div>
        <div className={styles.itemRight}>
          <p className={styles.time}>
            <span className={styles.itemF}>{tranObj.name}</span>
            <span className={styles.itemR}>{item.created_at}</span>
          </p>
          <div className={styles.tip}>
            {notify_type == 16 &&
            (action == 'qa_question_merchant' ||
              action == 'qa_answer_merchant') ? (
              <div>
                <p style={{ marginBottom: 5 }}>
                  {noticeContent.length && noticeContent.length > 50
                    ? noticeContent.substr(0, 50) + '...'
                    : noticeContent}
                </p>
                <p
                  className={classNames(styles.question, {
                    [styles.answer]: action == 'qa_answer_merchant'
                  })}
                >
                  {qa_content && qa_content.length > 30
                    ? qa_content.substr(0, 30) + '...'
                    : qa_content}
                </p>
              </div>
            ) : noticeContent.length && noticeContent.length > 90 ? (
              <Tooltip title={noticeContent}>
                {noticeContent.substr(0, 90) + '...'}
              </Tooltip>
            ) : (
              noticeContent
            )}
          </div>

          <Flex
            style={{ justifyContent: 'flex-end' }}
            className={styles.action}
          >
            {merchantId != noticeMerchantId && (
              <LoginSub
                hasAuth={getObjValue(item, 'merchant_info.has_auth')}
                storeId={getObjValue(item, 'merchant_info.m_store_id')}
                className={styles.detail}
              >
                来源：{merchant_name + merchant_city}
                <span>登录管理</span>
              </LoginSub>
            )}
            {!!linkUrl &&
              is_main_merchant && (
                <span className={styles.detail}>查看详情</span>
              )}
          </Flex>
        </div>
      </li>
    )
  }
  render() {
    const { noticeList } = this.props.store

    let items = noticeList.map(item => this.getItem(item))
    return (
      <ul className={styles.list}>
        {noticeList.length > 0 ? (
          items
        ) : (
          <p className={styles.noNotice}>暂无通知</p>
        )}
      </ul>
    )
  }
}
